import { render } from "./Loader.vue?vue&type=template&id=69343b8e&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=69343b8e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69343b8e"

export default script